class ThemesExplorer {
    init() {
        const container = document.querySelector('[data-themes-explorer]');
        if (!container) {
            return;
        }

        const cards = container.querySelectorAll('[data-theme-toggle]');
        const panels = document.querySelectorAll('[data-theme-panel]');

        const closeAll = () => {
            cards.forEach(c => {
                c.classList.remove('theme--active', 'theme--inactive');
                c.setAttribute('aria-expanded', 'false');
            });
            panels.forEach(p => p.classList.add('d-none'));
        };

        const openTheme = (themeId) => {
            cards.forEach(c => {
                if (c.dataset.themeId === themeId) {
                    c.classList.add('theme--active');
                    c.classList.remove('theme--inactive');
                    c.setAttribute('aria-expanded', 'true');
                } else {
                    c.classList.remove('theme--active');
                    c.classList.add('theme--inactive');
                    c.setAttribute('aria-expanded', 'false');
                }
            });
            panels.forEach(p => {
                if (p.dataset.themePanel === themeId) {
                    p.classList.remove('d-none');
                } else {
                    p.classList.add('d-none');
                }
            });
        };

        const toggleTheme = (themeId) => {
            const card = container.querySelector(`[data-theme-id="${themeId}"]`);
            if (card && card.classList.contains('theme--active')) {
                closeAll();
            } else {
                openTheme(themeId);
            }
        };

        cards.forEach(card => {
            card.addEventListener('click', () => toggleTheme(card.dataset.themeId));
            card.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleTheme(card.dataset.themeId);
                }
            });
        });
    }
}

export default new ThemesExplorer();
